(function() {
  document.addEventListener("DOMContentLoaded", function() {
    let currentIdx = 0;
    let imgUrls = [];
    let isZoomed = false;
    let zoomScale = 1;
    let isZoomFeatureAllowed = true; // Settings Toggle State Check
    
    let slideshowTimer = null;
    let progressInterval = null;
    let currentProgressWidth = 0;
    const slideDuration = 3000;

    let touchStartX = 0;
    let touchEndX = 0;
    const swipeMinDistance = 50;

    function cleanUniqueProductMediaTrack() {
      const parentBlock = document.querySelector('.grid__item.product__media-wrapper') || document.querySelector('.product__media-list') || document.querySelector('[class*="product__media"]');
      if(!parentBlock) return [];
      
      const images = parentBlock.querySelectorAll('img');
      let cleanUrls = [];
      images.forEach(img => {
        const src = img.getAttribute('data-zoom-src') || img.getAttribute('data-src') || img.src;
        if(src && !cleanUrls.includes(src) && !img.closest('.thumbnail-list') && !img.className.includes('thumb')) {
          cleanUrls.push(src);
        }
      });
      return cleanUrls;
    }

    document.body.addEventListener("click", function(e) {
      const mainContainer = document.querySelector('[id^="MainProduct-"]');
      if (mainContainer && mainContainer.getAttribute('data-lb-enabled') === 'false') return;

      const targetImg = e.target.closest('.product__media-item img, .product__image-container img, .product__modal-opener img, [class*="product__media"] img');
      if (!targetImg || e.target.closest('#PremiumHybridLightbox')) return;

      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      imgUrls = cleanUniqueProductMediaTrack();
      const currentSrc = targetImg.getAttribute('data-zoom-src') || targetImg.getAttribute('data-src') || targetImg.src;
      currentIdx = imgUrls.indexOf(currentSrc);
      if (currentIdx < 0) currentIdx = 0;

      openPremiumLightbox(mainContainer);
    }, true);

    function openPremiumLightbox(mainContainer) {
      const modal = document.getElementById("PremiumHybridLightbox");
      if (!modal) return;

      document.body.classList.add('lightbox-scroll-lock');

      // READ WORKABLE ADMIN CUSTOMIZER CONFIGURATION PARAMETERS
      const layoutMode = mainContainer ? (mainContainer.getAttribute('data-lb-position') || 'right') : 'right';
      const mobLayoutMode = mainContainer ? (mainContainer.getAttribute('data-lb-mobile-layout') || 'off') : 'off';
      isZoomFeatureAllowed = mainContainer ? (mainContainer.getAttribute('data-zoom-allowed') !== 'false') : true;

      // Mount control settings values directly onto layout component nodes
      modal.setAttribute('data-layout-mode', layoutMode);
      modal.setAttribute('data-mobile-layout', mobLayoutMode);

      // Change layout pointer rules relative to toggle configurations
      const zoomBtn = modal.querySelector('.lb-act-zoom-only');
      if (zoomBtn) {
        zoomBtn.style.display = isZoomFeatureAllowed ? 'flex' : 'none';
      }

      modal.style.display = "flex";
      
      buildLayoutTrackRails(mobLayoutMode);
      updateLightboxSlide();
      initZoomAndTouchEngine();
    }

    function buildLayoutTrackRails(mobLayoutMode) {
      const sideTrack = document.getElementById("PLightboxSideTrack");
      const bottomTrack = document.getElementById("PLightboxBottomTrack");
      
      if(sideTrack) sideTrack.innerHTML = "";
      if(bottomTrack) bottomTrack.innerHTML = "";

      // Logic parsing criteria conditions to isolate mobile views from layout structures
      const isMobile = window.innerWidth <= 840;
      if (isMobile && mobLayoutMode === 'off') return;

      imgUrls.forEach((url, i) => {
        const thumb = document.createElement("img");
        thumb.src = url;
        thumb.classList.add("p-universal-thumb-node");
        thumb.setAttribute('data-target-idx', i);
        if (i === currentIdx) thumb.classList.add("is-active-item");
        
        thumb.addEventListener("click", function(e) {
          e.stopPropagation();
          currentIdx = i;
          resetProgressTimeline();
          updateLightboxSlide();
        });
        
        if (sideTrack) sideTrack.appendChild(thumb.cloneNode(true));
        if (bottomTrack) bottomTrack.appendChild(thumb);
      });

      // Attach re-binded sync parameters to active items inside track collections
      if(sideTrack) {
        sideTrack.querySelectorAll('.p-universal-thumb-node').forEach((el, index) => {
          el.addEventListener('click', () => { currentIdx = index; resetProgressTimeline(); updateLightboxSlide(); });
        });
      }
    }

    function updateLightboxSlide() {
      const mainImg = document.getElementById("PHybridMainImg");
      const counter = document.getElementById("PLightboxCounter");
      if (!mainImg) return;

      isZoomed = false;
      zoomScale = 1;
      mainImg.style.transform = "scale(1)";
      mainImg.style.cursor = isZoomFeatureAllowed ? "zoom-in" : "default";
      mainImg.style.transformOrigin = "center center";

      mainImg.src = imgUrls[currentIdx];
      if (counter) counter.innerText = `${currentIdx + 1} / ${imgUrls.length}`;

      document.querySelectorAll('.p-universal-thumb-node').forEach(thumb => {
        if (parseInt(thumb.getAttribute('data-target-idx')) === currentIdx) {
          thumb.classList.add('is-active-item');
          thumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        } else {
          thumb.classList.remove('is-active-item');
        }
      });
    }

    // --- Dynamic Zoom Execution Layer Interceptor Hook ---
    window.triggerMasterZoomToggle = function(e) {
      if (!isZoomFeatureAllowed) return; // Completely ignores click trigger if toggle setting is OFF

      const mainImg = document.getElementById("PHybridMainImg");
      if (!mainImg) return;

      if (!isZoomed) {
        isZoomed = true;
        zoomScale = window.innerWidth <= 840 ? 3.0 : 2.5; 
        mainImg.style.transform = `scale(${zoomScale})`;
        mainImg.style.cursor = "zoom-out";
        if(e) executePanMatrix(e);
      } else {
        isZoomed = false;
        zoomScale = 1;
        mainImg.style.transform = "scale(1)";
        mainImg.style.cursor = "zoom-in";
        mainImg.style.transformOrigin = "center center";
      }
    };

    function initZoomAndTouchEngine() {
      const stage = document.getElementById("PLightboxStage");
      const mainImg = document.getElementById("PHybridMainImg");
      if (!stage || !mainImg) return;

      mainImg.addEventListener("click", function(e) {
        e.stopPropagation();
        window.triggerMasterZoomToggle(e);
      });

      stage.addEventListener("mousemove", function(e) {
        if (!isZoomed || !isZoomFeatureAllowed || window.innerWidth <= 840) return;
        executePanMatrix(e);
      });

      stage.addEventListener("touchmove", function(e) {
        if (!isZoomed || !isZoomFeatureAllowed || window.innerWidth > 840) return;
        executePanMatrix(e.touches[0]);
      }, { passive: true });

      // Swipe layout logic hooks
      stage.addEventListener("touchstart", function(e) {
        if (isZoomed) return;
        touchStartX = e.changedTouches[0].screenX;
      }, { passive: true });

      stage.addEventListener("touchend", function(e) {
        if (isZoomed) return;
        touchEndX = e.changedTouches[0].screenX;
        
        const distanceX = touchEndX - touchStartX;
        if (Math.abs(distanceX) > swipeMinDistance) {
          if (distanceX < 0) {
            currentIdx = (currentIdx + 1) % imgUrls.length;
          } else {
            currentIdx = (currentIdx - 1 + imgUrls.length) % imgUrls.length;
          }
          resetProgressTimeline();
          updateLightboxSlide();
        }
      }, { passive: true });
    }

    function executePanMatrix(point) {
      const stage = document.getElementById("PLightboxStage");
      const mainImg = document.getElementById("PHybridMainImg");
      if(!stage || !mainImg) return;
      
      const rect = stage.getBoundingClientRect();
      const xPercent = ((point.clientX - rect.left) / rect.width) * 100;
      const yPercent = ((point.clientY - rect.top) / rect.height) * 100;
      
      mainImg.style.transformOrigin = `${Math.max(0, Math.min(100, xPercent))}% ${Math.max(0, Math.min(100, yPercent))}%`;
    }

    function startProgressTimeline() {
      const progressBar = document.getElementById("PLightboxProgressBar");
      resetProgressTimeline();

      progressInterval = setInterval(() => {
        currentProgressWidth += (100 / (slideDuration / 100));
        if (progressBar) progressBar.style.width = `${currentProgressWidth}%`;

        if (currentProgressWidth >= 100) {
          currentIdx = (currentIdx + 1) % imgUrls.length;
          updateLightboxSlide();
          startProgressTimeline();
        }
      }, 100);
    }

    function resetProgressTimeline() {
      if (progressInterval) clearInterval(progressInterval);
      currentProgressWidth = 0;
      const progressBar = document.getElementById("PLightboxProgressBar");
      if (progressBar) progressBar.style.width = "0%";
    }

    document.body.addEventListener("click", function(e) {
      if (e.target.closest('.lb-act-close')) {
        document.getElementById("PremiumHybridLightbox").style.display = "none";
        document.body.classList.remove('lightbox-scroll-lock');
        resetProgressTimeline();
        if(slideshowTimer) { clearInterval(slideshowTimer); slideshowTimer = null; }
        document.querySelector('.lb-act-slideshow').style.color = "#ffffff";
      }
      if (e.target.closest('.ctrl-next')) {
        currentIdx = (currentIdx + 1) % imgUrls.length;
        resetProgressTimeline();
        updateLightboxSlide();
      }
      if (e.target.closest('.ctrl-prev')) {
        currentIdx = (currentIdx - 1 + imgUrls.length) % imgUrls.length;
        resetProgressTimeline();
        updateLightboxSlide();
      }
      if (e.target.closest('.lb-act-zoom-only')) {
        e.stopPropagation();
        window.triggerMasterZoomToggle(null);
      }
      if (e.target.closest('.lb-act-fullscreen')) {
        if (!document.fullscreenElement) document.documentElement.requestFullscreen();
        else if (document.exitFullscreen) document.exitFullscreen();
      }
      if (e.target.closest('.lb-act-slideshow')) {
        const btn = e.target.closest('.lb-act-slideshow');
        if (!slideshowTimer) {
          btn.style.color = "#ff0000";
          startProgressTimeline();
          slideshowTimer = true;
        } else {
          btn.style.color = "#ffffff";
          resetProgressTimeline();
          slideshowTimer = null;
        }
      }
    });

    document.addEventListener("keydown", function(e) {
      const modal = document.getElementById("PremiumHybridLightbox");
      if (!modal || modal.style.display !== "flex") return;
      if (e.key === "Escape") { modal.style.display = "none"; document.body.classList.remove('lightbox-scroll-lock'); resetProgressTimeline(); }
      if (e.key === "ArrowRight") { currentIdx = (currentIdx + 1) % imgUrls.length; resetProgressTimeline(); updateLightboxSlide(); }
      if (e.key === "ArrowLeft") { currentIdx = (currentIdx - 1 + imgUrls.length) % imgUrls.length; resetProgressTimeline(); updateLightboxSlide(); }
    });
  });
})();